<template>
  <div class="bg-gray-100 p-4">
    <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
      Flexprops schema toevoegen en wijzigen
    </p>
    <p>
      Voor deze functionaliteit is een
      <router-link
        :to="{ name: 'HelpFlexprops' }"
        class="underline text-mi-blue-500"
        >helppagina</router-link
      >
    </p>
    <nav class="tabs flex flex-col sm:flex-row mx-2 border-b-2 border-gray-300">
      <button
        data-target="panel-1"
        @click="openTab('current')"
        class="py-2 px-6 block hover:text-mi-blue-500 focus:outline-none"
        :class="{
          'border-b-2': tab == 'current',
          'border-mi-blue-500': tab == 'current',
          'font-medium': tab == 'current',
          'text-mi-blue-500': tab == 'current',
          'text-mi-blue-400': tab != 'current'
        }"
      >
        Huidig schema</button
      ><button
        data-target="panel-2"
        @click="openTab('suggested')"
        class="py-2 px-6 block hover:text-mi-blue-500 focus:outline-none"
        :class="{
          'border-b-2': tab == 'suggested',
          'border-mi-blue-500': tab == 'suggested',
          'font-medium': tab == 'suggested',
          'text-mi-blue-500': tab == 'suggested',
          'text-mi-blue-400': tab != 'suggested'
        }"
      >
        Voorgesteld schema
      </button>
    </nav>
    <div v-if="tab == 'current'" class="m-2">
      <CurrentFlexPropsSchema
        :flexprop_schema_current="voorziening_type.flexprop_schema_current"
      ></CurrentFlexPropsSchema>
    </div>
    <div v-if="tab == 'suggested'" class="m-2">
      <SuggestFlexPropsSchema :voorziening_type="voorziening_type" />
    </div>
  </div>
</template>

<script>
import CurrentFlexPropsSchema from "./CurrentFlexPropsSchema.vue";
import SuggestFlexPropsSchema from "./SuggestFlexPropsSchema.vue";
export default {
  name: "EditFlexpropsSchema",
  data() {
    return {
      tab: "current",
      msg: null,
      editmode: false,
      suggested_schema: null,
      suggested_schema_present_at_load: false,
      voorziening_type: null
    };
  },
  methods: {
    loadVoorzieningType: function() {
      this.voorziening_type = this.$store.state.backend_data.services.filter(
        item => item.id == this.$route.params.id
      )[0];
      this.suggested_schema = JSON.stringify(
        this.voorziening_type.flexprop_schema_suggested,
        null,
        4
      );
      this.suggested_schema_present_at_load = this.voorziening_type
        .flexprop_schema_suggested
        ? true
        : false;
      this.editmode = this.voorziening_type.flexprop_schema_suggested
        ? false
        : true;
    },
    openTab: function(tabname) {
      this.$store.dispatch("loadServices"); //this loads all Services. Might be too slow, but still an operation we don't do too often
      this.loadVoorzieningType();
      this.tab = tabname;
    }
  },
  created: function() {
    this.loadVoorzieningType();
  },
  components: { CurrentFlexPropsSchema, SuggestFlexPropsSchema }
};
</script>
